export default "__VITE_ASSET__Br4rr7B3__";